import { Card, Table } from 'antd'
import getClientConversationDashboardStat from 'api/dashboard/getClientConversationDashboardStat'
import React, { useEffect, useState } from 'react'

interface TableDataState {
	key: string
	firstName: string
	conversationcount: number
}
const columns = [
	{
		title: 'Name',
		dataIndex: 'firstName',
		key: 'firstName',
		width: '80%',
	},
	{
		title: 'Conversations',
		dataIndex: 'conversationcount',
		key: 'conversationcount',
	},
]
interface PropType {
	clientId: string
}
const ConversationPerUserCard: React.FC<PropType> = ({ clientId }) => {
	const [loading, setLoading] = useState<boolean>(true)
	const [tableData, setTableData] = useState<TableDataState[]>([])
	useEffect(() => {
		const fetchConversatsionStats = async () => {
			setLoading(true)
			try {
				const response = await getClientConversationDashboardStat({
					client: clientId,
				})
				const data = response.map(ele => {
					return {
						key: ele._id,
						firstName: ele.firstName,
						conversationcount: ele.conversation,
					}
				})
				setTableData(data)
				setLoading(false)
			} catch {
				setLoading(false)
			}
		}
		fetchConversatsionStats()
	}, [clientId])

	return (
		<Card title='Conversation Stats'>
			<Table
				dataSource={tableData}
				columns={columns}
				loading={loading}
				pagination={{ pageSize: 6 }}
			/>
		</Card>
	)
}

export default ConversationPerUserCard
